import { noop } from '@resn/gozer-misc';
import { gsap } from 'gsap';

class FlyInTransition {
    constructor(object, shader, animationProps) {
        this.name = 'flyIn';
        this.object = object;
        this.shader = shader;
        this.animationProps = animationProps;
        this.transparent = true;
        this.tl = null;

        this.init();
    }

    setTransitionUniforms(shader) {
        shader.USE_TRANSITION_SHINE = true;
        // shader.needsUpdate = true;
    }

    createCustomMeshes = noop;

    update = noop;

    init = () => {
        const { target, position, rotation, rotationTarget, reduceMotion } = this.animationProps;

        if (reduceMotion) {
            position.z = target.z = 3.4;
            position.y = target.y = -0.3;
        } else {
            position.z = target.z = 7;
            position.y = target.y = 4;
        }

        rotation.x = rotationTarget.x = -Math.PI * 0.5;
        rotation.y = rotationTarget.y = 0;
        rotation.z = rotationTarget.z = (Math.random() * 2 - 1) * (Math.PI * 0.4);

        if (this.shader.uniforms.u_matcapRotation)
            this.shader.uniforms.u_matcapRotation.value = 0;

    };

    start = () => {
        const { target, rotationTarget } = this.animationProps;
        const duration = 2;

        this.tl?.kill();
        this.tl = gsap
            .timeline()
            .to(
                target,
                {
                    duration: duration + 0.5,
                    ease: 'sine.out',
                    z: 0,
                },
                0
            )
            .to(
                target,
                {
                    duration: duration * 0.85,
                    ease: 'sine.inOut',
                    y: 0,
                },
                0
            )
            .to(
                rotationTarget,
                {
                    duration: duration + 0.25,
                    ease: 'quad.inOut',
                    x: 0,
                    y: 0,
                    z: 0,
                },
                0
            );

        return this.tl;
    };

    destroy = () => {
        this.tl?.kill();
        this.tl = null;
    };

    reset = () => {
        this.tl?.kill();
        this.tl = null;
    };
}

export { FlyInTransition };
